import React from 'react';
import { Box, SxProps } from '@mui/material';
import { useFilterContext } from '../../FilterContext';
import { useListContext } from '../../../ListContext';
import { useUiTheme } from 'framework/uiTheme';
import { Button } from '../../../../ui/mui-builder/Button/Button';

interface StaticFiltersLayoutProps {
  children: React.ReactElement;
  actionButtonName?: string;
  buttons?: React.ReactNode;
  sx?: SxProps;
}

const resolveButtons = (
  apply: () => void,
  loading?: boolean,
  buttons?: React.ReactNode | ((params: any) => React.ReactNode),
) => {
  return typeof buttons === 'function' ? buttons({ apply, disabled: loading }) : buttons;
};

const StaticFiltersLayout = ({ children, actionButtonName = 'Apply', buttons, sx }: StaticFiltersLayoutProps) => {
  const { apply } = useFilterContext();
  const { loading } = useListContext();
  const { Button: ThemedButton = Button } = useUiTheme();

  const overrideButtons = !!buttons;

  const defaultButton = (
    <ThemedButton color="primary" sx={{ display: 'flex' }} onClick={() => apply()} disabled={loading}>
      {actionButtonName}
    </ThemedButton>
  );

  const applyButton = overrideButtons ? resolveButtons(apply, loading, buttons) : defaultButton;

  return (
    <>
      <Box sx={{ maxWidth: { xs: '100%', lg: '50%', xl: '35%' }, ...sx }}>{children}</Box>

      {applyButton}
    </>
  );
};

export default StaticFiltersLayout;
